module.exports = __webpack_public_path__ + "static/media/man_breaking_bird_home3.91e0074d.gif";